import "babel-polyfill";
import "whatwg-fetch";
import 'promise-polyfill/src/polyfill.js';
// import '../main.mjs';
import * as Helper from '../weave/helpers.mjs';
import {FurnitureBasketIndex} from './classes/furniture_basket.js';

let form = document.getElementById("searchForm");
new FurnitureBasketIndex(form, {
    actions: {
        addToOrder: new Helper.EntityAction({
            route: '/furniture/addToBasket',
            extraValue: document.getElementById("furnitureBasketInfo")
        }),
        removeFromWishlist: new Helper.EntityAction({
            route: '/furniture/removeFromWishlist'
        })
    }
});